import { createIntl, createIntlCache } from 'react-intl';
import en from './locales/en/en_US.json';
import enTutorial from './locales/en/en_US_tutorial.json';
import es from './locales/es/es_ES.json';
import esTutorial from './locales/es/es_ES_tutorial.json';
import pt from './locales/pt/pt_PT.json';
import ptTutorial from './locales/pt/pt_PT_tutorial.json';

export const messages = {
  en: { ...en, ...enTutorial },
  es: { ...es, ...esTutorial },
  pt: { ...pt, ...ptTutorial },
};

const cache = createIntlCache();

let intl;

export const initIntl = ( locale = 'en' ) => {
  intl = createIntl(
    {
      locale,
      messages: messages[locale] || messages.en, // Fallback a 'en'
    },
    cache,
  );
};

export const formatMessage = ( id, defaultMessage = '', values ) => {
  if ( !intl ) {
    throw new Error( 'Intl not initialized. Call initIntl first.' );
  }
  return intl.formatMessage( { id, defaultMessage }, values );
};
